// extracted by mini-css-extract-plugin
module.exports = {"text":"text_2rPFs","input":"input_SlZ5e","answer":"answer_19XhH"};